import { createSharedSlice } from '@luna/state';

import type { MessageId } from './TemporaryMessagesTypes';

export const useTemporaryMessagesState = createSharedSlice({
    name: 'temporaryMessages/state',
    initialState: {
        isMessageDisplayed: false,
        isMessageCollapsed: false,
        closedMessagesIds: [] as MessageId[],
        collapsedMessagesIds: [] as MessageId[],
    },
    reducers: {
        setIsMessageDisplayed(state, action: { payload: boolean }) {
            state.isMessageDisplayed = action.payload;
        },
        setIsMessageCollapsed(state, action: { payload: boolean }) {
            state.isMessageCollapsed = action.payload;
        },
        addClosedMessageId(state, action: { payload: MessageId }) {
            state.closedMessagesIds = [...state.closedMessagesIds, action.payload];
        },
        expandMessage(state, action: { payload: MessageId }) {
            const idIndex = state.collapsedMessagesIds.indexOf(action.payload);

            if (idIndex === -1) {
                return;
            }

            state.collapsedMessagesIds.splice(idIndex, 1);
        },
        collapseMessage(state, action: { payload: MessageId }) {
            const idIndex = state.collapsedMessagesIds.indexOf(action.payload);

            if (idIndex > -1) {
                return;
            }

            state.collapsedMessagesIds.push(action.payload);
        },
    },
});
